var Lead = Lead || {};
export default Lead.Address = Lead.Address || {};

// AddressCompleter - an object which will set up address autocompletion on an input field and populate
// a set of other fields with the resulting address components.  See the constructor for configuration.

Lead.Address.AutoCompleter = function () {
    // The address input field
    this.input = getField('Postal Address');

    // The fields which should be populated with the address components
    this.outputs = {
        street: getField('street'),
        suburb: getField('suburb'),
        city: getField('city'),
        country: getField('country'),
        postcode: getField('postcode')
    };

    // The versions of the address components that we want
    this.components = {
        street_number: 'long_name',
        route: 'long_name',
        sublocality_level_1: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
    };

    // The types of objects that the Google API will return
    this.types = ['address'];

    // The circle, with center and radius in latitude/longitude and meters, used to bias the autocomplete results.
    // Set to null to remove address biasing.
    this.bias = {
        lat: -36.848448,
        lng: 174.7600023,
        radius: 0
    };

    // getField(name) - look up input and output fields in the form
    //
    // Because these fields are automatically generated by WFFM they don't have meaningful ids, so we rely on the
    // "data-val-length" property of the element containing text like "The Postal Address field must be a string
    // with a minimum length of..." to identify them.
    function getField (name) {
        var inputs = $('input')
            .filter(function () {
                var attr = this.getAttribute('data-val-length');
                return attr && attr.match(new RegExp('The ' + name + ' field'));
            })
            .toArray();

        return inputs[0];
    }
};

// defaultAction() - what to do when the Google API doesn't complete successfully
Lead.Address.AutoCompleter.prototype.defaultAction = function () {
    $(this.outputs.street).val($(this.input).val());
};

// apiCallback() - passed to the Google API, this initializes autocompletion and handles the results.
//
// The Google API functions will exist by the time this function is called, but eslint doesn't know that,
// so we need to disable no-undef for those lines.
Lead.Address.AutoCompleter.prototype.apiCallback = function () {
    var autocomplete = new google.maps.places.Autocomplete(this.input, { // eslint-disable-line no-undef
        types: this.types
    });

    if (this.bias) {
        var circle = new google.maps.Circle({ // eslint-disable-line no-undef
            center: new google.maps.LatLng(this.bias.lat, this.bias.lng), // eslint-disable-line no-undef
            radius: this.bias.radius
        });

        autocomplete.setBounds(circle.getBounds());
    }

    var self = this;

    autocomplete.addListener('place_changed', function () {
        $(self.outputs.street).val('');
        $(self.outputs.suburb).val('');
        $(self.outputs.city).val('');
        $(self.outputs.country).val('');
        $(self.outputs.postcode).val('');

        var place = autocomplete.getPlace();

        if (!place.geometry) {
            self.defaultAction();
        }
        else {
            $(self.outputs.street).val(self.getComponent(place, 'street_number') + ' ' + self.getComponent(place, 'route'));
            $(self.outputs.suburb).val(self.getComponent(place, 'sublocality_level_1'));
            $(self.outputs.city).val(self.getComponent(place, 'locality'));
            $(self.outputs.country).val(self.getComponent(place, 'country'));
            $(self.outputs.postcode).val(self.getComponent(place, 'postal_code'));
        }
    });
};

// getComponent(place, type) - look up an address component from a Google place result
Lead.Address.AutoCompleter.prototype.getComponent = function (place, type) {
    var component = place.address_components.find(function (c) {
        return c.types[0] === type;
    });

    return component ? component[this.components[type]] : '';
};

Lead.Address.AutoCompleter.prototype.hasValidForm = function () {
    if (!this.input) {
        return false;
    }

    var outputFields = Object.getOwnPropertyNames(this.outputs);

    if (outputFields.length !== outputFields.filter(name => this.outputs[name]).length) {
        return false;
    }

    return true;
};

// If we create an AutoCompleter in, say, forms.js, then that variable will be uglified and its apiCallback
// function can't be specified in the Google API request string, so we instantiate one here which will be
// exported with this library.

Lead.Address.globalAutoCompleter = Lead.Address.globalAutoCompleter || new Lead.Address.AutoCompleter();


// WEBPACK FOOTER //
// ./Assets/js/TeWanangaRedesign/address-autocompleter.js